import { siteMessageReadByMessageId } from '@/api/user'

export function useAtividadeModel(props, emit) {
  const router = useRouter()

  const activeForm = reactive({
    id: 1,
    title: '',
    content: '',
    img: '',
    type: 1,
    jump_type: 1,
    jump_url: '',
  })

  const change = (e) => {
    for (const key in activeForm) {
      activeForm[key] = e[key]
    }

    if (props.isHasUnRead) {
      props.list.find((item, i) => {
        if (item.id === e.id) {
          props.list[i].unRead = false
          return true
        }
      })
      setSiteMessageReadByMessageId(e.id)
    }

    emit('change', e)
  }

  const setSiteMessageReadByMessageId = async (site_message_id) => {
    await siteMessageReadByMessageId({
      site_message_id,
    })
  }

  const iconType = (type) => {
    switch (type) {
      case 1:
        return 'chat'
      case 2:
        return 'volume'
      default:
        return 'chat'
    }
  }

  const jumpUrl = (url) => {
    if (url && url !== null) {
      switch (activeForm.jump_type) {
        case 1:
          router.push({ name: url })
          emit('close')
          break
        case 2:
          window.open(url, '_blank')
          break
      }
    }
  }

  return {
    activeForm,
    change,
    iconType,
    jumpUrl,
  }
}
